import { useState } from 'react';
import './des.css';
import axios from 'axios';
import { Typography, TextField, Button, CircularProgress, Container, Paper, Avatar, Box } from '@mui/material';
import ReactMarkdown from 'react-markdown'; // Import ReactMarkdown for rendering Markdown

function Teach() {
  const [ques, setQues] = useState("");
  const [load, setLoad] = useState(false);
  const [ans, setAnswer] = useState("");

  const generateAnswer = async () => {
    console.log("QUES : ", ques);
    setLoad(true);
    setAnswer("Thinking...");
    console.log("loading....");
    try {
      const res = await axios({
        url: "https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=AIzaSyAPPEU_P0uVM2sx2S29EmexjHX6jsoxTWQ",
        method: "post",
        data: {
          "contents": [{ "parts": [{ "text": `${ques}` }] }]
        },
      });
      setAnswer(res['data']['candidates'][0]['content']['parts'][0]['text']);
      console.log(res['data']['candidates'][0]['content']['parts'][0]['text']);
    } catch (error) {
      setAnswer("Error generating answer.");
      console.error(error);
    } finally {
      setLoad(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} style={{ padding: 20, marginTop: 30 }}>
          <Avatar sx={{ bgcolor: 'orange', width: 40, height: 40 }}>
            <Typography variant="h5" sx={{ fontSize: 30, color: 'white' }}>
              S
            </Typography>
          </Avatar>
          <Typography variant='h3' fontWeight={600} align="center" gutterBottom>Salahkar</Typography>
        <TextField
          multiline
          rows={5}
          value={ques}
          onChange={(e) => setQues(e.target.value)}
          placeholder="Enter your question..."
          variant="outlined"
          fullWidth
          margin="normal"
        />
        <Button
          onClick={generateAnswer}
          variant="contained"
          color="primary"
          fullWidth
          style={{ marginBottom: 20 }}
        >
          ASK
        </Button>
        <div style={{ marginTop: 20, textAlign: 'center' }}>
          <Typography variant='h5'>Here's you go:</Typography>
          {load ? (
            <CircularProgress />
          ) : (
            <div style={{ color: '#666', marginTop: 10 }}>
              {ans ? (
                <ReactMarkdown>{ans}</ReactMarkdown> // Render Markdown content
              ) : (
                <Typography variant='body1'>No answer yet.</Typography>
              )}
            </div>
          )}
        </div>
      </Paper>
    </Container>
  );
}

export default Teach;
